module.exports = __webpack_public_path__ + "img/Settings.962bcf58.svg";